import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-secondary)";

export default function IconActivityScreenUpdated({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M12 6.5a.5.5 0 0 1 0 1H9a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 1 1 0V16a1.5 1.5 0 0 1-1.5 1.5H9A1.5 1.5 0 0 1 7.5 16V8A1.5 1.5 0 0 1 9 6.5h3zm3.781-.267a.3.3 0 0 1 .438 0l1.646 1.756a.5.5 0 0 1-.73.685l-.635-.678v3.236a.5.5 0 0 1-1 0V7.995l-.635.678a.5.5 0 0 1-.73-.685l1.646-1.756z"/>
        </svg>
    );
}
